import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Button, Paper, Box } from "@mui/material";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalPhoneRoundedIcon from "@mui/icons-material/LocalPhoneRounded";
import { FormA } from "../../components/form";
import dayjs from "dayjs";
import useModalState from "../../../hooks/use-modal-state";
import PreviousActiveDialog from "./features/previous-active-dialog";
import { cloneDeep } from "lodash";

const completedStatus = [
    "Completed",
    "Language Barrier",
    "Call done",
    "Invalid",
    "Not in the portal",
    "Miscarriage",
    "Deceased Child",
    "Deceased Mother",
    "Deceased (Mother and Child)",
    "Duplicate Mother Id",
    "Wrong number",
    "Declined",
    "Out of service",
    "Duplicate Mother Id",
];
const retryStatus = [
    // 'Declined',
    "No answer",
    "Busy",
    "No network",
    "Invalid",
    "Incoming not available",
    "Call Incomplete",
    "Switched off",
    "Out of service",
];

const retryExceededStatus = [
    // 'Declined',
    "No answer",
    "Busy",
    "No network",
    "Incoming not available",
    "Call Incomplete",
    "Switched off",
    "Out of service",
];

const Sidebar = ({ data, onChange, selected }) => {
    const [activeList, setActiveList] = useState({});
    const [inactiveList, setInactiveList] = useState({});
    const [completeList, setCompleteList] = useState({});
    const [retryList, setRetryList] = useState({});
    const [rescheduledList, setRescheduledList] = useState({});
    const [previousActiveList, setPreviousActiveList] = useState({});
    const [scheduledLaterList, setScheduledLaterList] = useState({});


    const [inactiveListG, setInactiveListG] = useState([]);
    const [formData, setFormData] = useState({});

    /**
     * Modal state for the previous active cases
     */
    const {
        isOpen: openPreviousActiveModal,
        data: previousActiveData,
        openModal: openPreviousActiveModalHandler,
        closeModal: closePreviousActiveModalHandler
    } = useModalState();

    /**
     * Method to update the previousActiveList
     */
    const updatePreviousActiveList = (caseData) => {
        // Previous Active Cases Copy
        let previousActiveCasesCopy = cloneDeep(previousActiveList);

        /**
         * Now the shape of the list is like this
         * {
         *    contact: {
         *      contact: string
         *      calls: []
         *    }
         * }
         * 
         * So we need to go through the list find the id that matches and removed it (filter it)
         * So first find the contact matching and then filter out the calls
         */

        // Find the contact
        const contact = previousActiveCasesCopy[caseData.contact];

        // Filter the calls
        contact.calls = contact.calls.filter((call) => {
            return call._id !== caseData._id;
        });

        // assign the contact list to the copy
        previousActiveCasesCopy[caseData.contact] = contact;

        // Check if the calls array is empty after filtering
        if (contact.calls.length === 0) {
            // Remove the entire contact group if no calls remain
            delete previousActiveCasesCopy[caseData.contact];
        }

        // assign the copy to the state
        setPreviousActiveList(previousActiveCasesCopy);
    }

    const getLength = (obj) => {
        let c = 0;
        for (const key in obj) {
            c += obj[key].calls.length;
        }
        return c;
    };

    const getGroupCalls = (e) => {
        return [
            ...(activeList[e.contact]?.calls || []),
            ...(inactiveList[e.contact]?.calls || []),
            ...(completeList[e.contact]?.calls || []),
            ...(retryList[e.contact]?.calls || []),
            ...(rescheduledList[e.contact]?.calls || []),
            ...(scheduledLaterList[e.contact]?.calls || []),
            ...(previousActiveList[e.contact]?.calls || []),
        ];
    };

    useEffect(() => {
        if (Array.isArray(data)) {
            const Acases = data
                .filter((e) => e.status == "Active")
                // need to filter out the active cases that are not of today
                .filter((e) => {
                    return dayjs().isSame(dayjs(e.callDate), "day");
                })
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );
            // console.log('---------------------->',Acases)
            setActiveList(
                Acases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );

            const scheduledLaterCases = data
                .filter((e) => e.status == "Schedule Later")
                .filter((e) => {
                    return dayjs().isSame(dayjs(e.callDate), "day");
                })
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );

            setScheduledLaterList(
                scheduledLaterCases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );

            const prevActiveCases = data
                .filter((e) => e.status == "Active")
                .filter((e) => {
                    return dayjs(e.callDate).isBefore(dayjs(), "day");
                }).filter((e) => {
                    console.log(formData, "FormData", e.contact, "E CONTACT")
                    return formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true
                }).map(e => {
                    return {
                        ...e,
                        previousActive: true
                    }
                });

            setPreviousActiveList(
                prevActiveCases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );

            const ICases = data
                .filter((e) => e.status == "Pending")
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );
            // console.log('---------------------->',ICases)
            setInactiveList(
                ICases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );
            const CCases = data
                .filter(
                    (e) =>
                        completedStatus.includes(e.status) ||
                        (e.attempt > 2 && retryExceededStatus.includes(e.status)),
                )
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );

            setCompleteList(
                CCases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );

            let today = dayjs();
            const RCases = data
                .filter(
                    (e) =>
                    // (e.attempt < 2 && retryStatus.includes(e.status)) 
                    // e.status === "Pending"
                    // &&
                    // (e.attempt < 3 && today.isSame(e.callDate, "day") && e.rescheduled && (e.status !== "Queue" && e.status !== "Pending"
                    //     && e.status !== "Active"
                    // )),
                    (
                        e.attempt < 3
                        &&
                        today.isSame(e.callDate, "day")
                        && (
                            e.status !== "Queue"
                            &&
                            e.status !== "Pending"
                            &&
                            e.status !== "Active"
                        )
                        &&
                        retryStatus.includes(e.status)
                    ),
                )
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );
            setRetryList(
                RCases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );

            // Rescheduled Cases
            const rescheduledCases = data
                .filter((kase) => {
                    return (
                        !today.isSame(kase.callDate, "day") &&
                        kase.rescheduled &&
                        kase.attempt < 2
                    );
                })
                .filter((kase) => {
                    return kase.status !== "Active";
                })
                .filter((rKase) => {
                    // call date of the case
                    let callDate = rKase.callDate;

                    // we have rescheduled cases which means it must have a reschduleHistory
                    let rescheduleHistory = rKase.rescheduleHistory;

                    // we take the last item
                    let lastReschedule = rescheduleHistory[rescheduleHistory.length - 1];

                    let today = dayjs();

                    // we check if the last reschedule date is today
                    let isToday = today.isSame(lastReschedule.rescheduledTo, "day");

                    // we also check if the today is greater than the rescheduled date
                    let isGreaterThan = today.isAfter(
                        lastReschedule.rescheduledTo,
                        "day",
                    );
                    let isCallDateGreaterThanToday = today.isAfter(callDate, "day");

                    if (isCallDateGreaterThanToday) {
                        // we skip beacuse its greater
                        return false;
                    }

                    // multiple return statements
                    // first we handle if its greater than today
                    // if (isGreaterThan) {
                    //     // we skip beacuse its greater
                    //     return false;
                    // }

                    if (isToday) {
                        // we skip if its today
                        return false;
                    }

                    // if today, then we skip else we include
                    return true;
                })
                .filter((e) =>
                    formData.contact && e.contact
                        ? e.contact.includes(formData.contact)
                        : true,
                );

            setRescheduledList(
                rescheduledCases.reduce((a, e) => {
                    if (!a[e.contact]) {
                        a[e.contact] = {
                            contact: e.contact,
                            calls: [],
                        };
                    }
                    a[e.contact].calls.push(e);
                    return a;
                }, {}),
            );
        }
    }, [data, formData.contact]);

    return (
        <>
            <div style={{}}>
                {/* <FormA fields={[
                    {
                        name: "contact",
                        type: "text",
                        label: "Group by contact",
                    }
                ]}

                    onChange={(name, value, multiple) => {
                        formData[name] = value
                        setFormData({ ...formData })
                    }}
                    state={formData || {}}
                /> */}

                <Paper elevation={3} sx={{ height: "80vh", overflow: "scroll" }}>
                    <Accordion defaultExpanded={true}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1a-content"
                            id="panel1a-header"
                            sx={{ background: "#e5f9f3", border: "1px solid #bef1e3" }}
                        >
                            <Typography
                                color="success"
                                sx={{ color: "#009c70", fontWeight: "bold" }}
                            >
                                Ongoing ({activeList && getLength(activeList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {activeList &&
                                Object.values(activeList).map((el, i) => (
                                    <>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                                sx={{
                                                    background: "#f2f7ff",
                                                    border: "1px solid #ffeab2",
                                                }}
                                            >
                                                {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                <LocalPhoneRoundedIcon
                                                    sx={{ color: "rgb(111, 77, 174)" }}
                                                />
                                                {/* group with its numbers */}
                                                <Typography
                                                    variant="p"
                                                    sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                >
                                                    G :: {el.contact}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: 0 }}>
                                                {el.calls &&
                                                    el.calls.map((e, j) => {
                                                        // console.log('=====>',e, e.name)
                                                        return (
                                                            <Box
                                                                key={j}
                                                                sx={{
                                                                    borderBottom: "1px solid #e5efff",
                                                                    height: "45px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    background:
                                                                        selected && e._id == selected._id
                                                                            ? "#f2f7ff"
                                                                            : "",
                                                                    padding: "0px 10px 0px 10px",
                                                                }}
                                                                onClick={() => {
                                                                    onChange(e, getGroupCalls(e));
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="p"
                                                                    sx={{
                                                                        color: "#183b56",
                                                                        fontSize: "14px",
                                                                        ml: 1,
                                                                    }}
                                                                >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                            </Box>
                                                        );
                                                    })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                    // <Box key={i} sx={{
                                    //     borderBottom: '1px solid #e5efff', height: '45px',
                                    //     display: 'flex', alignItems: 'center', cursor: 'pointer',
                                    //     background: selected && el._id == selected._id ? '#f2f7ff' : '',
                                    //     padding: '0px 10px 0px 10px'
                                    // }}
                                    //     onClick={() => {
                                    //         onChange(el)
                                    //     }}
                                    // >
                                    //     <LocalPhoneRoundedIcon sx={{ color: 'rgb(111, 77, 174)' }} /> <Typography variant='p' sx={{ color: '#183b56', fontSize: '14px', ml: 1 }}>{`${el.name} :: ${el.contact || ''}`}</Typography>
                                    // </Box>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel2a-content"
                            id="panel2a-header"
                            sx={{ background: "#fff5d9", border: "1px solid #ffeab2" }}
                        >
                            <Typography sx={{ color: "#cc9500", fontWeight: "bold" }}>
                                Assigned ({inactiveList && getLength(inactiveList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {inactiveList &&
                                Object.values(inactiveList).map((el, i) => {
                                    // console.log('===>',el)
                                    return (
                                        // inactiveList._id ?
                                        <>
                                            <Accordion>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                    id="panel2a-header"
                                                    sx={{
                                                        background: "#f2f7ff",
                                                        border: "1px solid #ffeab2",
                                                    }}
                                                >
                                                    {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                    <LocalPhoneRoundedIcon
                                                        sx={{ color: "rgb(111, 77, 174)" }}
                                                    />
                                                    {/* group with its numbers */}
                                                    <Typography
                                                        variant="p"
                                                        sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                    >
                                                        G :: {el.contact}
                                                    </Typography>
                                                </AccordionSummary>
                                                <AccordionDetails sx={{ padding: 0 }}>
                                                    {el.calls &&
                                                        el.calls.map((e, j) => {
                                                            // console.log('=====>',e, e.name)
                                                            return (
                                                                <Box
                                                                    key={j}
                                                                    sx={{
                                                                        borderBottom: "1px solid #e5efff",
                                                                        height: "45px",
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        cursor: "pointer",
                                                                        background:
                                                                            selected && e._id == selected._id
                                                                                ? "#f2f7ff"
                                                                                : "",
                                                                        padding: "0px 10px 0px 10px",
                                                                    }}
                                                                    onClick={() => {
                                                                        onChange(e, getGroupCalls(e));
                                                                    }}
                                                                >
                                                                    <Typography
                                                                        variant="p"
                                                                        sx={{
                                                                            color: "#183b56",
                                                                            fontSize: "14px",
                                                                            ml: 1,
                                                                        }}
                                                                    >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                                </Box>
                                                            );
                                                        })}
                                                </AccordionDetails>
                                            </Accordion>
                                        </>
                                    );
                                })}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel3a-content"
                            id="panel3a-header"
                            sx={{ background: "#ccd5de", border: "1px solid #e5efff" }}
                        >
                            <Typography sx={{ color: "#375674", fontWeight: "bold" }}>
                                Attempted ({completeList && getLength(completeList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {completeList &&
                                Object.values(completeList).map((el, i) => (
                                    <>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                                sx={{
                                                    background: "#f2f7ff",
                                                    border: "1px solid #ffeab2",
                                                }}
                                            >
                                                {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                <LocalPhoneRoundedIcon
                                                    sx={{ color: "rgb(111, 77, 174)" }}
                                                />
                                                {/* group with its numbers */}
                                                <Typography
                                                    variant="p"
                                                    sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                >
                                                    G :: {el.contact}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: 0 }}>
                                                {el.calls &&
                                                    el.calls.map((e, j) => {
                                                        // console.log('=====>',e, e.name)
                                                        return (
                                                            <Box
                                                                key={j}
                                                                sx={{
                                                                    borderBottom: "1px solid #e5efff",
                                                                    height: "45px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    background:
                                                                        selected && e._id == selected._id
                                                                            ? "#f2f7ff"
                                                                            : "",
                                                                    padding: "0px 10px 0px 10px",
                                                                }}
                                                                onClick={() => {
                                                                    onChange(e, getGroupCalls(e));
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="p"
                                                                    sx={{
                                                                        color: "#183b56",
                                                                        fontSize: "14px",
                                                                        ml: 1,
                                                                    }}
                                                                >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                            </Box>
                                                        );
                                                    })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                    // <Box key={i} sx={{
                                    //     borderBottom: '1px solid #e5efff', height: '45px',
                                    //     display: 'flex', alignItems: 'center', cursor: 'pointer',
                                    //     background: selected && el._id == selected._id ? '#f2f7ff' : '',
                                    //     padding: '0px 10px 0px 10px'
                                    // }}
                                    //     onClick={() => {
                                    //         onChange(el)
                                    //     }}
                                    // >
                                    //     <LocalPhoneRoundedIcon sx={{ color: 'rgb(111, 77, 174)' }} />
                                    //     <Typography variant='p' sx={{ color: '#183b56', fontSize: '14px', ml: 1 }}>{`${el.name} :: ${el.contact || ''}`}</Typography>
                                    // </Box>
                                ))}
                        </AccordionDetails>
                    </Accordion>
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                            sx={{ background: "#ccd5de", border: "1px solid #e5efff" }}
                        >
                            <Typography sx={{ color: "#375674", fontWeight: "bold" }}>
                                For Reattempt ({retryList && getLength(retryList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {retryList &&
                                Object.values(retryList).map((el, i) => (
                                    <>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                                sx={{
                                                    background: "#f2f7ff",
                                                    border: "1px solid #ffeab2",
                                                }}
                                            >
                                                {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                <LocalPhoneRoundedIcon
                                                    sx={{ color: "rgb(111, 77, 174)" }}
                                                />
                                                {/* group with its numbers */}
                                                <Typography
                                                    variant="p"
                                                    sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                >
                                                    G :: {el.contact}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: 0 }}>
                                                {el.calls &&
                                                    el.calls.map((e, j) => {
                                                        // console.log('=====>',e, e.name)
                                                        return (
                                                            <Box
                                                                key={j}
                                                                sx={{
                                                                    borderBottom: "1px solid #e5efff",
                                                                    height: "45px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    background:
                                                                        selected && e._id == selected._id
                                                                            ? "#f2f7ff"
                                                                            : "",
                                                                    padding: "0px 10px 0px 10px",
                                                                }}
                                                                onClick={() => {
                                                                    onChange(e, getGroupCalls(e));
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="p"
                                                                    sx={{
                                                                        color: "#183b56",
                                                                        fontSize: "14px",
                                                                        ml: 1,
                                                                    }}
                                                                >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                            </Box>
                                                        );
                                                    })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                    // <Box key={i} sx={{
                                    //     borderBottom: '1px solid #e5efff', height: '45px',
                                    //     display: 'flex', alignItems: 'center', cursor: 'pointer',
                                    //     background: selected && el._id == selected._id ? '#f2f7ff' : '',
                                    //     padding: '0px 10px 0px 10px'
                                    // }}
                                    //     onClick={() => {
                                    //         onChange(el)
                                    //     }}
                                    // >
                                    //     <LocalPhoneRoundedIcon sx={{ color: 'rgb(111, 77, 174)' }} />
                                    //     <Typography variant='p' sx={{ color: '#183b56', fontSize: '14px', ml: 1 }}>{`${el.name} :: ${el.contact || ''}`}</Typography>
                                    // </Box>
                                ))}
                        </AccordionDetails>
                    </Accordion>

                    {/* Schedules Later */}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                            sx={{ background: "#ccd5de", border: "1px solid #e5efff" }}
                        >
                            <Typography sx={{ color: "#375674", fontWeight: "bold" }}>
                                Scheduled Later ({scheduledLaterList && getLength(scheduledLaterList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {scheduledLaterList &&
                                Object.values(scheduledLaterList).map((el, i) => (
                                    <>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                                sx={{
                                                    background: "#f2f7ff",
                                                    border: "1px solid #ffeab2",
                                                }}
                                            >
                                                {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                <LocalPhoneRoundedIcon
                                                    sx={{ color: "rgb(111, 77, 174)" }}
                                                />
                                                {/* group with its numbers */}
                                                <Typography
                                                    variant="p"
                                                    sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                >
                                                    G :: {el.contact}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: 0 }}>
                                                {el.calls &&
                                                    el.calls.map((e, j) => {
                                                        // console.log('=====>',e, e.name)
                                                        return (
                                                            <Box
                                                                key={j}
                                                                sx={{
                                                                    borderBottom: "1px solid #e5efff",
                                                                    height: "45px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    background:
                                                                        selected && e._id == selected._id
                                                                            ? "#f2f7ff"
                                                                            : "",
                                                                    padding: "0px 10px 0px 10px",
                                                                }}
                                                                onClick={() => {
                                                                    onChange(e, getGroupCalls(e));
                                                                    // openScheduledLaterModalHandler(e);
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="p"
                                                                    sx={{
                                                                        color: "#183b56",
                                                                        fontSize: "14px",
                                                                        ml: 1,
                                                                    }}
                                                                >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                            </Box>
                                                        );
                                                    })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                ))}
                        </AccordionDetails>
                    </Accordion>

                    {/* Previous Active Cases */}
                    <Accordion>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel4a-content"
                            id="panel4a-header"
                            sx={{ background: "#ccd5de", border: "1px solid #e5efff" }}
                        >
                            <Typography sx={{ color: "#375674", fontWeight: "bold" }}>
                                Previous Active ({previousActiveList && getLength(previousActiveList)})
                            </Typography>
                        </AccordionSummary>
                        <AccordionDetails sx={{ padding: 0 }}>
                            {previousActiveList &&
                                Object.values(previousActiveList).map((el, i) => (
                                    <>
                                        <Accordion>
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon />}
                                                aria-controls="panel2a-content"
                                                id="panel2a-header"
                                                sx={{
                                                    background: "#f2f7ff",
                                                    border: "1px solid #ffeab2",
                                                }}
                                            >
                                                {/* <Typography sx={{ color: '#cc9500', fontWeight: 'bold' }}>Assigned ({inactiveList && inactiveList.length})</Typography> */}
                                                <LocalPhoneRoundedIcon
                                                    sx={{ color: "rgb(111, 77, 174)" }}
                                                />
                                                {/* group with its numbers */}
                                                <Typography
                                                    variant="p"
                                                    sx={{ color: "#183b56", fontSize: "14px", ml: 1 }}
                                                >
                                                    G :: {el.contact}
                                                </Typography>
                                            </AccordionSummary>
                                            <AccordionDetails sx={{ padding: 0 }}>
                                                {el.calls &&
                                                    el.calls.map((e, j) => {
                                                        // console.log('=====>',e, e.name)
                                                        return (
                                                            <Box
                                                                key={j}
                                                                sx={{
                                                                    borderBottom: "1px solid #e5efff",
                                                                    height: "45px",
                                                                    display: "flex",
                                                                    alignItems: "center",
                                                                    cursor: "pointer",
                                                                    background:
                                                                        selected && e._id == selected._id
                                                                            ? "#f2f7ff"
                                                                            : "",
                                                                    padding: "0px 10px 0px 10px",
                                                                }}
                                                                onClick={() => {
                                                                    // onChange(e, getGroupCalls(e));
                                                                    openPreviousActiveModalHandler(e);
                                                                }}
                                                            >
                                                                <Typography
                                                                    variant="p"
                                                                    sx={{
                                                                        color: "#183b56",
                                                                        fontSize: "14px",
                                                                        ml: 1,
                                                                    }}
                                                                >{`${e.name} :: ${e.contact || ""}`}</Typography>
                                                            </Box>
                                                        );
                                                    })}
                                            </AccordionDetails>
                                        </Accordion>
                                    </>
                                ))}
                        </AccordionDetails>
                    </Accordion>



                </Paper>
                <PreviousActiveDialog
                    open={openPreviousActiveModal}
                    handleClose={closePreviousActiveModalHandler}
                    data={previousActiveData}
                    onChange={onChange}
                    updatePreviousActiveList={updatePreviousActiveList}
                />
            </div>
        </>
    );
};

export default Sidebar;
